<span class="tag bike"
  ><img src="assets/images/icons/svg/bike-icon.svg" alt="icon" class="icon" /> {{ count }} Ride{{
    count > 1 ? 's' : ''
  }}</span
>
